// How many of a Multi-select value's names fit on one line. Pure arithmetic over widths the caller measured,
// so every case is tested without a browser.

// Between two names, on every surface that writes a Multi-select value as text, as the service's display
// value does.
export const MULTI_SELECT_SEPARATOR = ', ';

export type NamesFit = {
	// How many names are shown, from the first; the rest are counted in "+N".
	shown: number;
	// Whether the first name is cut with an ellipsis, because not even it fits beside the "+N" (or, when it is
	// the only name, in the line at all).
	cutFirst: boolean;
};

/**
 * How many whole names fit in `available` pixels, in their order, with `separatorWidth` between two names and
 * room for "+N" when any are left out. `moreWidth(n)` is the width of "+n" with the gap before it. When every
 * name fits, all are shown and there is no "+N". Otherwise the most names that fit beside the "+N" for the
 * rest; when not even the first does, the first is shown cut short, followed by "+N" (or alone).
 */
export const fitNames = (
	nameWidths: number[],
	available: number,
	separatorWidth: number,
	moreWidth: (hidden: number) => number
): NamesFit => {
	const count = nameWidths.length;
	if (count === 0) return {shown: 0, cutFirst: false};
	// lineWidths[n]: the first n names and the separators between them.
	const lineWidths = [0];
	nameWidths.forEach((width, index) => lineWidths.push(lineWidths[index] + width + (index > 0 ? separatorWidth : 0)));
	if (lineWidths[count] <= available) return {shown: count, cutFirst: false};
	for (let shown = count - 1; shown >= 1; shown--) {
		if (lineWidths[shown] + moreWidth(count - shown) <= available) return {shown, cutFirst: false};
	}
	return {shown: 1, cutFirst: true};
};
